import React from 'react';
import styled from 'styled-components/macro';
import { DeviceSize } from '../components/basic/DeviceSize';
import { Body2 } from '../components/common';
import { parseMessageToList } from '../utils/messages';
import { useFormattedMessageGetter } from '../hooks/useFormattedMessageGetter';
import { useMessageGetter } from 'react-message-context';

const DescriptionContainer = styled.div`
  margin: 20px 0 0;

  li {
    padding: 2px 0;
  }

  @media ${DeviceSize.mobileL} {
    ul {
      padding-left: 20px;
    }
  }
`;

const ServiceDescription = () => {
  const t = useFormattedMessageGetter('signin.step1');
  const tRaw = useMessageGetter('signin.step1');

  return (
    <DescriptionContainer>
      <Body2>{t('descriptionTitle')}</Body2>
      {parseMessageToList(tRaw('descriptionItems'))}
      <Body2>{t('authdescription')}</Body2>
    </DescriptionContainer>
  );
};

export default ServiceDescription;
